<template>
    <div :class="propCols==undefined ? 'col-lg-5 col-md-6' : 'col-lg-12'">
        <div class="form-group">
            <label for="nameEstInput">Estimate Name <small>(Optional)</small></label>
            <input type="text" :class="['form-control', (disabledSteps.customer) ? 'disabled' : '']"
                :disabled="disabledSteps.customer" id="nameEstInput" maxlength="60" v-model="document_name"
                placeholder="Document name" @change="updateData" />
        </div>
        <div class="form-group showtooltip">
            <!-- <label for="job_information" v-if="jobinfomationcheck">{{ jobinfomationtitle }} <small>(Optional)</small></label> -->
            <!--<textarea v-model="job_information"
                id="job_information"
                :class="['form-control', (disabledSteps.customer) ? 'disabled' : '']"
                maxlength="200"
                :disabled="!jobinfomationcheck || disabledSteps.customer"
                :placeholder="jobinfomationtitle+': '+((jobinfomationcheck) ? 'Let your client know what this Estimate is for:' : 'Field disabled, set in settings')"
                @change="updateData"
            ></textarea>
            <span class="maxSize">
                {{ (job_information!=null) ? job_information.length : 0 }}/200
            </span>-->
            <!-- @keypress="noEnter" -->
            <!-- <span class="tooltip">prueba de tootlip</span> -->
            <editor-job-info :value="job_information" :limit="numberWords" :limitType="'words'"
                :placeholder="'Let your client know what this Estimate is for:'" :readonly="disabledSteps.customer"
                :editorClass="'form-control job_information '" @input="updateData"
                :emitOnLimitReached="true"></editor-job-info>
        </div>
    </div>
</template>
<script>
import RichTextEditor from './../../RichTextEditor.vue'
export default {
    props: [
        "controlLoad",
        "propdisabledSteps",
        "propdocument_name",
        "propjob_information",
        "propCols",
    ],
    components: {
        "editor-job-info": RichTextEditor,
    },
    data() {
        return {
            disabledSteps: this.propdisabledSteps,
            document_name: this.propdocument_name,
            job_information: this.propjob_information,
            jobinfomationcheck: true,
            jobinfomationtitle: "Job information",
            numberWords: 50,
        }
    },
    created() {
        let t = this;
    },
    watch: {
        controlLoad: function () {
            let t = this;
            if (this.controlLoad) {
                if (this.propjob_information != null && this.propjob_information != undefined && this.propjob_information != '') {
                    // console.log('watch InfoEst job_information', this.propjob_information);
                    this.job_information = this.propjob_information;
                }
                if (this.propdocument_name && this.propdocument_name != null && this.propdocument_name != undefined && this.propdocument_name != '') {
                    // console.log('watch InfoEst document_name', this.propdocument_name);
                    this.document_name = this.propdocument_name;
                }
                t.getEstimateSetting();
            }
        },
    },
    methods: {
        getEstimateSetting() {
            let t = this;
            window.apiv2
                .get("estimates/setting/" + window.localuserdata)
                .then((response) => {
                    console.log('getEstimateSetting', response.data.result);
                    if (response.data.result.length) {
                        let r = response.data.result[0];
                        t.jobinfomationcheck = r.jobinfomationcheck;
                        t.jobinfomationtitle = r.jobinfomationtitle;
                        if(t.job_information == null || t.job_information == undefined || t.job_information == '') {
                            t.job_information = r.jobinfomationtext;
                        }
                        t.updateData(t.job_information)
                        t.getKeyValSetting('job_information_numberWords', 50).then((resul) => {
                            this.numberWords = parseInt(resul);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getKeyValSetting (meta_key, valueDefault) {
            return new Promise((resolve, reject) => {
                try{
                    window.apiv2
                    .post('getKeyValSetting', {
                        user_id: window.master_client,
                        org_id: window.localorgdata,
                        meta_key: meta_key,
                    })
                    .then((response) => {
                        // console.log(meta_key, response.data);
                        resolve(response.data.status ? response?.data?.r?.meta_value : valueDefault);
                    });
                }catch(e){
                    resolve(valueDefault);
                    reject(valueDefault);
                }
            });
        },
        noEnter(e) {
            var code = (e.which) ? e.which : e.keyCode;
            if (code == 13) {
                return e.preventDefault();
            }
        },
        updateData(data) {
            let t = this;
            data = (data == null || data == undefined) ? t.job_information : data;
            data = (typeof data == 'string') ? data : "";
            // console.log('updateData job_information', data)
            t.$emit('updateProps', {
                "document_name": t.document_name,
                "job_information": data,
            })
        },
    },
};
</script>
<style>
.job_information,
.quillWrapper.job_information {
    margin: -0.375rem -0.75rem;
    width: 100%;
    min-width: 383px;
    min-height: 135px;
    max-height: 135px;
    height: auto;
    overflow: hidden;
    overflow-y: auto;
}

.quillWrapper.job_information .ql-editor li:not(.ql-direction-rtl)::before {
    left: -5px !important;
}

@media (max-width: 390px) {
    .job_information {
        min-width: 100%;
    }

}
</style>
